import React, { useState, useEffect, useContext } from 'react'
import { Row, Col, Form, Button, Modal, Card } from 'react-bootstrap'
import { css, StyleSheet } from 'aphrodite/no-important'
import FeatherIcon from 'feather-icons-react'
import styles from 'designer/styles/modal.module.css'
import { Avatar } from '@material-ui/core'
import httpClient, { getBaseURL } from 'utility/httpClient.util'
import moment from 'moment'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import objectPath from 'object-path'
import { DesignContext } from 'contexts/DesignContext'

const AttachmentView = (props) => {
  const designContext = useContext(DesignContext)
  const { jsonForm, setFormData, isUiChanged, setIsUiChanged } = designContext
  const formData = objectPath.get(jsonForm, 'formData') || {}
  const { uiKey } = props
  let saveKey = `@attachments.${uiKey}`
  let attachments = objectPath.get(formData, saveKey) || []
  const filterAttachment = attachments.filter(({ attachmentId }) =>
    attachmentId ? attachmentId !== -1 : true
  )

  const attachmentsLength = filterAttachment.length - 1
  const { formatDateTime } = useTimeFormat()

  const [currentItem, setCurrentItem] = useState({})
  const [currentIndex, setCurrentIndex] = useState(0)

  const [isOpen, setIsOpen] = useState(false)

  const onOpen = () => setIsOpen(true)
  const onHide = () => setIsOpen(false)

  const gotoPrevious = () => {
    setCurrentIndex((prevState) => {
      let index = prevState - 1
      setCurrentItem(filterAttachment[index])
      return index
    })
  }

  const gotoNext = () => {
    setCurrentIndex((prevState) => {
      let index = prevState + 1
      setCurrentItem(filterAttachment[index])
      return index
    })
  }

  const gotoItem = (item, index) => {
    onOpen()
    setCurrentIndex(index)
    setCurrentItem(item)
  }

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window
    return { width, height }
  }

  const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    )

    useEffect(() => {
      const handleResize = () => {
        setWindowDimensions(getWindowDimensions())
      }
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }, [])

    return windowDimensions
  }

  const { height } = useWindowDimensions()

  const deleteAttachment = (index) => {
    let attachment = objectPath.get(attachments, index)
    if (attachment?.attachmentId) {
      objectPath.set(attachments, [index, 'attachmentId'], -1)
    } else {
      objectPath.del(attachments, index)
    }
    objectPath.set(formData, saveKey, attachments)
    setFormData(formData)
    objectPath.set(isUiChanged, uiKey, {
      isRender: true,
    })
    setIsUiChanged(isUiChanged)
  }

  const renderAttachments = () => {
    if (!filterAttachment) return
    let gallery = filterAttachment.map((item, index) => {
      let {
        ext = '',
        contentType = '',
        originalFileName = '',
        thumbnail,
        thumbnailPath,
        attachmentId,
      } = item
      let type = contentType && contentType.split('/').shift()
      let baseUrl = getBaseURL()
      let src = attachmentId
        ? `${baseUrl}/${thumbnailPath}`
        : thumbnail || item.src
      ext =
        attachmentId && originalFileName
          ? originalFileName.split('.').pop()
          : ext

      if (!type || !ext || !src) return
      let cover
      if (type === 'image') {
        cover = (
          <img
            className="rounded"
            src={src}
            style={{
              border: 0,
              display: 'block',
              width: '80px',
              height: '50px',
              objectFit: 'cover',
            }}
            alt={originalFileName}
          />
        )
      } else if (type === 'video') {
        cover = (
          <video
            className="rounded"
            src={src}
            style={{
              border: 0,
              display: 'block',
              width: '80px',
              height: '50px',
              objectFit: 'cover',
            }}
            alt={originalFileName}
          />
        )
      } else {
        cover = (
          <Avatar
            variant="rounded"
            alt={originalFileName}
            children={originalFileName.substring(0, 1)}
            style={{
              width: '80px',
              height: '50px',
              fontSize: '24px',
              backgroundColor: 'gray',
            }}
          />
        )
      }

      return (
        <Col xs={12} key={index} className="mb-1">
          <div className="img-thumbnail">
            <Row className="w-100 mx-auto">
              <Col className="px-1">
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={() => gotoItem(item, index)}
                >
                  <div className="d-flex">
                    {cover}
                    <Row className="w-100 mx-auto align-content-center">
                      <Col sm="12">
                        <h6 className="m-0 pb-1">
                          {item.originalFileName ?? item?.name}
                        </h6>
                      </Col>
                      <Col sm="12">
                        <Form.Label className="m-0 pt-1">
                          {item.dateTime ?? formatDateTime(new Date())}
                        </Form.Label>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col sm="auto" className="pl-0 pr-1 d-flex align-items-center">
                <Button
                  variant="outline-danger"
                  className="d-flex align-items-center justify-content-center py-1 px-1"
                  onClick={() => deleteAttachment(index)}
                >
                  <FeatherIcon icon="trash" size="16" />
                </Button>
              </Col>
            </Row>
          </div>
        </Col>
      )
    })
    return (
      <div className={css(classes.gallery)}>
        <Row>{gallery}</Row>
      </div>
    )
  }

  const renderFile = (item) => {
    let {
      originalFileName = '',
      contentType = '',
      thumbnail,
      originalPath,
      attachmentId,
      ext = '',
    } = item
    let baseUrl = getBaseURL()
    let src = attachmentId
      ? `${baseUrl}/${originalPath}`
      : thumbnail || item.src
    let type = contentType && contentType.split('/').shift()
    ext =
      attachmentId && originalFileName ? originalFileName.split('.').pop() : ext
    if (!type || !ext || !src) return
    if (type === 'image') {
      return (
        <div
          className="w-100 h-100"
          style={{ overflowY: 'auto', maxHeight: height - 200 }}
        >
          <img
            src={src}
            className="d-flex mx-auto"
            alt={originalFileName || item?.name}
          />
        </div>
      )
    }
    if (type === 'video') {
      return (
        <div
          className="w-100 h-100"
          style={{ overflowY: 'auto', maxHeight: height - 200 }}
        >
          <video
            src={src}
            className="d-flex mx-auto w-100 h-100"
            style={{ objectFit: 'contain' }}
            controls
            alt={originalFileName}
          />
        </div>
      )
    }
    if (ext === 'pdf' || ext === 'txt') {
      return (
        <iframe frameborder="0" width="100%" height="100%" src={src}></iframe>
      )
    }
    return (
      <iframe
        frameborder="0"
        src={`https://view.officeapps.live.com/op/embed.aspx?src=${src}`}
        width="100%"
        height="100%"
      ></iframe>
    )
  }

  return (
    <React.Fragment>
      <div className="section">
        {renderAttachments()}
        <Modal
          show={isOpen}
          onHide={onHide}
          fullscreen="true"
          dialogClassName={styles.modalFullScreen}
        >
          <Modal.Header closeButton>
            <Form.Label className="d-flex mb-0 align-items-center">
              <span className="font-weight-bold">
                {currentItem.originalFileName ?? currentItem?.name}
              </span>
              <span className="pl-2 pr-1">| วันที่เวลาบันทึก:</span>
              <span>
                {currentItem?.createdAt
                  ? formatDateTime(currentItem?.createdAt)
                  : formatDateTime(new Date())}
              </span>
            </Form.Label>
          </Modal.Header>
          <Modal.Body>{renderFile(currentItem)}</Modal.Body>
          <Modal.Footer className="p-3">
            <div className="d-flex justify-content-start">
              <Button
                id="previous-file"
                outline
                color="primary"
                disabled={currentIndex === 0}
                className="mx-50"
                onClick={gotoPrevious}
              >
                <FeatherIcon icon="chevron-left" size="16" />
                ก่อนหน้า
              </Button>
            </div>
            <div className="d-flex justify-content-start">
              <Button
                id="next-file"
                outline
                color="primary"
                disabled={currentIndex === attachmentsLength}
                className="mx-50"
                onClick={gotoNext}
              >
                <FeatherIcon icon="chevron-right" size="16" /> ถัดไป
              </Button>
            </div>
            <div className="d-flex justify-content-start mr-auto">
              <Form.Label className="d-flex align-items-center">
                {currentIndex + 1} / {attachmentsLength + 1}
              </Form.Label>
            </div>
            <div className="d-flex justify-content-end">
              <Button id="close-file" variant="light" onClick={onHide}>
                ปิด
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  )
}

AttachmentView.displayName = 'Gallery'

const gutter = {
  small: 2,
  large: 4,
}
const classes = StyleSheet.create({
  gallery: {
    marginRight: -gutter.small,
    overflow: 'hidden',

    '@media (min-width: 500px)': {
      marginRight: -gutter.large,
    },
  },
})

export default AttachmentView
